import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAccessToken();
    const activeTenantId = this.authService.getActiveTenantId(); // NUEVO: Extraer Tenant

    // Clonar e inyectar Token JWT
    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    // NUEVO: Inyectar Cabecera de Tenant para Superadmins o usuarios con Tenant activo
    if (activeTenantId) {
      request = request.clone({
        headers: request.headers.set('x-tenant-id', activeTenantId)
      });
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          !request.url.includes('auth/login') &&
          !request.url.includes('auth/refresh-token') 
        ) {
          return this.handle401Error(request, next);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        return this.authService.refreshToken().pipe(
          switchMap((response: any) => {
            this.isRefreshing = false;
            this.authService.setAccessToken(response.token);
            this.authService.setRefreshToken(response.refreshToken);
            this.refreshTokenSubject.next(response.token);

            // Re-inyectamos el nuevo access token
            let clonedReq = request.clone({
                setHeaders: { Authorization: `Bearer ${response.token}` }
            });
            // Re-inyectamos el tenant por si acaso
            const tId = this.authService.getActiveTenantId();
            if(tId) clonedReq = clonedReq.clone({ headers: clonedReq.headers.set('x-tenant-id', tId) });

            return next.handle(clonedReq);
          }),
          catchError((err) => {
            this.isRefreshing = false;
            this.authService.logout(true); 
            return throwError(err);
          })
        );
      } else {
         this.isRefreshing = false;
         this.authService.logout(true);
         return throwError("No refresh token available");
      }
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
            let clonedReq = request.clone({ setHeaders: { Authorization: `Bearer ${jwt}` } });
            const tId = this.authService.getActiveTenantId();
            if(tId) clonedReq = clonedReq.clone({ headers: clonedReq.headers.set('x-tenant-id', tId) });
            return next.handle(clonedReq);
        })
      );
    }
  }
}